<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Batas Pencarian Harga Gadai" 
                label-align="left"
            >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="mobileInput.MOBILE_LIMIT_CEK_HARGA_GADAI" type="number" required></b-form-input>
                        <span class="smallText text-muted">Batasan pencarian harga gadai oleh setiap nasabah dalam satu hari.</span>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-mobile-app" title="Confirm Edit Parameter Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter anggota ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'parameter-mobile-app',
    props: {
        mobileInput: { type: Object, required: true }
    },
    data() {
        return {
            isSubmitting: false,
            newData: {}
        }
    },
    methods: {

        onSubmit() {

            this.newData = JSON.parse(JSON.stringify(this.mobileInput))

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                this.$helper.toastSucc(this, "Parameter Mobile App telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-mobile-app")
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        openModalConfirm() {
            this.$bvModal.show("modal-edit-mobile-app")
        },
    }
}
</script>